type StrengthValueType = 'caps' | 'length' | 'special' | 'numbers' | 'small'

type StrengthValue = {
  [key in StrengthValueType]: boolean
}

const _strengthValue: StrengthValue = {
  caps: false,
  length: false,
  special: false,
  numbers: false,
  small: false,
}

const checkPasswordStrength = (password: string): number => {
  const strengthValue = { ..._strengthValue }

  if (password.length >= 8) {
    strengthValue.length = true
  }

  for (let index = 0; index < password.length; index++) {
    const char = password.charCodeAt(index)
    if (!strengthValue.caps && char >= 65 && char <= 90) {
      strengthValue.caps = true
    } else if (!strengthValue.numbers && char >= 48 && char <= 57) {
      strengthValue.numbers = true
    } else if (!strengthValue.small && char >= 97 && char <= 122) {
      strengthValue.small = true
    } else if (
      (!strengthValue.special && char >= 33 && char <= 47) ||
      (char >= 58 && char <= 64)
    ) {
      strengthValue.special = true
    }
  }

  let strengthIndicator = 0
  for (const metric in strengthValue) {
    if (strengthValue[metric as StrengthValueType] === true) {
      strengthIndicator++
    }
  }

  return strengthIndicator
}

const MAX_REPEAT_RUN = 4 // reject 4+ identical characters in a row, e.g. "aaaa"
const MIN_SEQUENCE_RUN = 4 // reject 4+ characters following a known order, e.g. "1234", "abcd"
const ORDERED_SEQUENCES = [
  'abcdefghijklmnopqrstuvwxyz',
  '0123456789',
  'qwertyuiop',
  'asdfghjkl',
  'zxcvbnm',
]

const hasRepeatedRun = (password: string): boolean => {
  let run = 1
  for (let index = 1; index < password.length; index++) {
    run = password[index] === password[index - 1] ? run + 1 : 1
    if (run >= MAX_REPEAT_RUN) {
      return true
    }
  }
  return false
}

const hasOrderedSequence = (password: string): boolean => {
  const lower = password.toLowerCase()

  return ORDERED_SEQUENCES.some((sequence) => {
    const forwardAndBackward = [sequence, [...sequence].reverse().join('')]

    return forwardAndBackward.some((ordered) => {
      for (let i = 0; i + MIN_SEQUENCE_RUN <= ordered.length; i++) {
        if (lower.includes(ordered.slice(i, i + MIN_SEQUENCE_RUN))) {
          return true
        }
      }
      return false
    })
  })
}

const isPredictablePassword = (password: string): boolean =>
  hasRepeatedRun(password) || hasOrderedSequence(password)

export { checkPasswordStrength, isPredictablePassword }
